<div class="container">
  <div>
    <div class="filters">
      @if (state.userHasMinType(1)) {
      <div class="filter">
        <lib-user-picker
          [users]="this.state.users$"
          [showAllEntry]="true"
          (selectedUserChanged)="userChange($event)"
        ></lib-user-picker>
      </div>
      }

      <div class="filter">
        <lib-month-picker
          (selectedValueChanged)="monthChange($event)"
          (selectedYearChanged)="yearChange($event)"
          [showAllEntry]="true"
        ></lib-month-picker>
      </div>
    </div>
    <div class="small-margin">
      <ion-button
        (click)="modalService.openAbsenceFormModal(null, selectedWorker)"
        ><ion-icon slot="start" size="small" color="light" name="add"></ion-icon
        >{{ "absence.new" | translate }}
      </ion-button>
      @if(selectedEntriesValid){
      <ion-button color="danger" (click)="delete()"
        ><ion-icon
          slot="start"
          size="small"
          color="light"
          name="trash-outline"
        ></ion-icon
        >{{ "common.delete" | translate }}
      </ion-button>
      }
    </div>

    <div class="custom-table">
      <div class="row header">
        <div class="col">
          <ion-checkbox
            [checked]="allSelected"
            (ionChange)="toggleAll()"
            (click)="$event.stopPropagation()"
          ></ion-checkbox>
        </div>
        <div class="col" style="display: flex; align-items: center">
          {{ "common.date" | translate }}
          <ion-icon
            size="small"
            style="color: black; cursor: default"
            name="caret-down-outline"
          ></ion-icon>
        </div>
        <div class="col grow">{{ "common.name" | translate }}</div>
        <div class="col">{{ "common.type" | translate }}</div>
        <div class="col"></div>
      </div>

      @for (wd of filteredEntries; track wd) {
      <div class="row" (click)="modalService.openAbsenceDetailModal(wd.id)">
        <div
          class="col"
          (click)="$event.stopPropagation(); toggleSelection(wd)"
        >
          <ion-checkbox
            [checked]="isSelected(wd)"
            (click)="$event.stopPropagation()"
            (ionChange)="toggleSelection(wd)"
          ></ion-checkbox>
        </div>
        <div class="col">
          {{ wd.date | date : "dd.MM.yyyy" }}
        </div>
        <div class="col grow">
          {{ state.getUserDisplayNameAsync(wd.user) | async }}
        </div>
        <div class="col">{{ wd.type }}</div>
        <div class="col">
          @if (wd.approvedBy) {
          <ion-icon
            style="color: rgb(0, 179, 0)"
            size="small"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (!wd.approvedBy && !wd.rejectedBy) {
          <ion-icon
            style="color: rgb(255, 174, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (wd.rejectedBy) {
          <ion-icon
            style="color: rgb(228, 0, 0)"
            name="close-circle-outline"
          ></ion-icon>
          }
        </div>
      </div>
      }
    </div>
  </div>
  <lib-table-legend [items]="[0, 1, 7]"></lib-table-legend>
</div>
